import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface CreateCardAccountModalProps {
  onLayout: (event: any) => void;
}

export enum CreateCardAccountStackRoutes {
  Main = 'main',
  Individual = 'individual',
  Document = 'document',
  Confirm = 'confirm',
  Placed = 'placed',
  SelectAccount = 'select-account',
  SelectCardAccount = 'select-card-account'
}

export type CreateCardAccountStackParamList = {
  [CreateCardAccountStackRoutes.Main]: CreateCardAccountModalProps & {
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [CreateCardAccountStackRoutes.Individual]: CreateCardAccountModalProps & {
    data: any;
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
    onBackData: (data: any) => void;
  };
  [CreateCardAccountStackRoutes.Document]: CreateCardAccountModalProps & {
    data: any;
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [CreateCardAccountStackRoutes.Confirm]: CreateCardAccountModalProps & {
    data: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [CreateCardAccountStackRoutes.Placed]: CreateCardAccountModalProps & {
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
  [CreateCardAccountStackRoutes.SelectAccount]: CreateCardAccountModalProps & {
    onSelect: (data: any) => void;
    onChangeView?: () => void;
    borderRadiusFlag?: boolean;
  };
  [CreateCardAccountStackRoutes.SelectCardAccount]: CreateCardAccountModalProps & {
    onSelect: (data: any) => void;
    onChangeView?: () => void;
    borderRadiusFlag?: boolean;
  };
};

export type CreateCardAccountStackScreenProps<Screen extends keyof CreateCardAccountStackParamList> = NativeStackScreenProps<
  CreateCardAccountStackParamList,
  Screen
>;
